// ソートキー
export const SORT_KEY = {
  CREATED: 'created',
  MODIFIED: 'modified',
  LATEST_STEP_DEADLINE: 'latestStepDeadline',
  LATEST_STEP_START_DATE: 'latestStepStartDate',
} as const;

// ソート順序
export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

export type SortKeyType = (typeof SORT_KEY)[keyof typeof SORT_KEY];
export type SortOrderType = (typeof SORT_ORDER)[keyof typeof SORT_ORDER];

// ソートオプション（組み合わせ）
export type SortOptionValue = {
  sortBy: SortKeyType;
  sortOrder: SortOrderType;
};

export type SortOption = {
  value: SortOptionValue;
  label: string;
};

export const SORT_OPTIONS = [
  {
    value: {sortBy: SORT_KEY.CREATED, sortOrder: SORT_ORDER.DESC},
    label: '新着順',
  },
  {
    value: {sortBy: SORT_KEY.MODIFIED, sortOrder: SORT_ORDER.DESC},
    label: '更新順',
  },
  {
    value: {sortBy: SORT_KEY.LATEST_STEP_DEADLINE, sortOrder: SORT_ORDER.ASC},
    label: '締切が近い順',
  },
  {
    value: {sortBy: SORT_KEY.LATEST_STEP_START_DATE, sortOrder: SORT_ORDER.ASC},
    label: '開始日が近い順',
  },
] as const satisfies readonly SortOption[];
